function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { extractSignificantDigits, getUnsafeNumberReason, isInteger, isNumber, UnsafeNumberReason } from './utils.js';
/**
 * A lossless number. Stores its numeric value as string
 */

export var LosslessNumber = /*#__PURE__*/function () {
  // numeric value as string
  // type information
  function LosslessNumber(value) {
    _classCallCheck(this, LosslessNumber);

    _defineProperty(this, "isLosslessNumber", true);

    if (!isNumber(value)) {
      throw new Error('Invalid number (value: "' + value + '")');
    }

    this.value = value;
  }
  /**
   * Get the value of the LosslessNumber as number or bigint.
   *
   * - a number is returned for safe numbers and decimal values that only lose some insignificant digits
   * - a bigint is returned for big integer numbers
   * - an Error is thrown for values that will overflow or underflow
   *
   * Note that you can implement your own strategy for conversion by just getting the value as string
   * via .toString(), and using util functions like isInteger, isSafeNumber, getUnsafeNumberReason,
   * and toSafeNumberOrThrow to convert it to a numeric value.
   */


  _createClass(LosslessNumber, [{
    key: "valueOf",
    value: function valueOf() {
      var unsafeReason = getUnsafeNumberReason(this.value); // safe or truncate_float

      if (unsafeReason === undefined || unsafeReason === UnsafeNumberReason.truncate_float) {
        return parseFloat(this.value);
      } // truncate_integer


      if (isInteger(this.value)) {
        return BigInt(this.value);
      } // overflow or underflow


      throw new Error('Cannot safely convert to number: ' + "the value '".concat(this.value, "' would ").concat(unsafeReason, " and become ").concat(parseFloat(this.value)));
    }
    /**
     * Get the value of the LosslessNumber as string.
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.value;
    } // Note: we do NOT implement a .toJSON() method, and you should not implement
    // or use that, it cannot safely turn the numeric value in the string into
    // stringified JSON since it has to be parsed into a number first.

  }]);

  return LosslessNumber;
}();
/**
 * Test whether a value is a LosslessNumber
 */

export function isLosslessNumber(value) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return value && _typeof(value) === 'object' && value.isLosslessNumber === true || false;
}
/**
 * Convert a number into a LosslessNumber if this is possible in a safe way
 * If the value has too many digits, or is NaN or Infinity, an error will be thrown
 */

export function toLosslessNumber(value) {
  if (extractSignificantDigits(value + '').length > 15) {
    throw new Error('Invalid number: contains more than 15 digits and is most likely truncated and unsafe by itself ' + "(value: ".concat(value, ")"));
  }

  if (isNaN(value)) {
    throw new Error('Invalid number: NaN');
  }

  if (!isFinite(value)) {
    throw new Error('Invalid number: ' + value);
  }

  return new LosslessNumber(String(value));
}
//# sourceMappingURL=LosslessNumber.js.map